/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CalendarDay/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import ActionsPopover from './ActionsPopover/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentHover from 'DesignSystem/Popover/PopoverContentHover/index'
import PopoverContentRightClick from 'DesignSystem/Popover/PopoverContentRightClick/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import SlotsPopover from './SlotsPopover/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import WeekIndicator from './WeekIndicator/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function CalendarDay({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/MonthlyCalendar/Content/CalendarDay"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let calendarDayIsOfficeDayValueData = fromData.useDataValue({ viewPath,
context: 'calendar_day',
path: 'is_office_day',
})
let calendarDayTemplateColorValueData = fromData.useDataValue({ viewPath,
context: 'calendar_day',
path: 'template_color',
})
let calendarDayIsFadedValueData = fromData.useDataValue({ viewPath,
context: 'calendar_day',
path: 'is_faded',
})
let calendarDayIsOptimalValueData = fromData.useDataValue({ viewPath,
context: 'calendar_day',
path: 'is_optimal',
})
let calendarDayConflictsPreferencesValueData = fromData.useDataValue({ viewPath,
context: 'calendar_day',
path: 'conflicts_preferences',
})
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let calendarDayOccupancyColorValueData = fromData.useDataValue({ viewPath,
context: 'calendar_day',
path: 'occupancy_color',
})
let calendarDayHasPercentageOfOccupancyValueData = fromData.useDataValue({ viewPath,
context: 'calendar_day',
path: 'has_percentage_of_occupancy',
})
let calendarDayIsSelectedValueData = fromData.useDataValue({ viewPath,
context: 'calendar_day',
path: 'is_selected',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let calendarDayDayValueData = fromData.useDataValue({ viewPath,
context: 'calendar_day',
path: 'day',
})
let calendarDayIsSelectedValueData1 = fromData.useDataValue({ viewPath,
context: 'calendar_day',
path: 'is_selected',
})
let calendarDayHasSlotsValueData = fromData.useDataValue({ viewPath,
context: 'calendar_day',
path: 'has_slots',
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
 showOnHover={true}
 hoverTriggerDelay={1000}
 showOnClick={false}
 showOnRightClick={true}
 offsetMainAxis={-8}
 data="calendar_day.is_office_day"
 disabled={!calendarDayIsOfficeDayValueData}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<React.Fragment>
<button
  data-testid="CalendarDay.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bc-1-2rE2z8': dtColorsNeutral200,'--bc-6-2rE2z8': calendarDayTemplateColorValueData,'--o-4-2rE2z8': calendarDayIsFadedValueData ? 0.5 : 1,'--bbw-2-2rE2z8': calendarDayIsOptimalValueData ? "4px" : "0.5px",'--bbc-3-2rE2z8': calendarDayIsOptimalValueData ? "#78A4F8" : dtColorsNeutral200,'--bi-5-2rE2z8': calendarDayConflictsPreferencesValueData ? "linear-gradient(to right, #CBD2D9 0.5px, transparent 0.5px),linear-gradient(to bottom, #CBD2D9 0.5px, transparent 0.5px)" : "none"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="CalendarDay.Horizontal"
  data-view-path={viewPath}
 style={{'--brc-7-2rE2z8': calendarDayOccupancyColorValueData,'--o-4-2rE2z8': calendarDayHasPercentageOfOccupancyValueData ? 1 : 0}}
 className={`views-block ${styles.Horizontal}`}
/>
<div
  data-testid="CalendarDay.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-6-2rE2z8': calendarDayIsSelectedValueData ? dtColorsNeutral900 : "transparent",'--btlr-8-2rE2z8': calendarDayIsSelectedValueData ? "50%" : "0%",'--btrr-9-2rE2z8': calendarDayIsSelectedValueData ? "50%" : "0%",'--bblr-10-2rE2z8': calendarDayIsSelectedValueData ? "50%" : "0%",'--bbrr-11-2rE2z8': calendarDayIsSelectedValueData ? "50%" : "0%"}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={calendarDayIsSelectedValueData1 ? dtColorsWhite : calendarDayHasSlotsValueData ? dtColorsNeutral900 : dtColorsNeutral500}
 weight={calendarDayHasSlotsValueData ? "bold" : "semibold"}
 data={calendarDayIsSelectedValueData1 ? "calendar_day.has_slots" : "calendar_day.day"}
 text={calendarDayDayValueData}
 data={calendarDayIsSelectedValueData1 ? "calendar_day.has_slots" : "calendar_day.is_selected"}
/>
</div>
</button>
<WeekIndicator
{...childProps}
  viewPath={`${viewPath}/WeekIndicator`}
/>
</React.Fragment>
)}
</PopoverTrigger>
<PopoverContentHover
{...childProps}
  viewPath={`${viewPath}/PopoverContentHover`}
>
{childProps => (
<SlotsPopover
{...childProps}
  viewPath={`${viewPath}/SlotsPopover`}
/>
)}
</PopoverContentHover>
<PopoverContentRightClick
{...childProps}
  viewPath={`${viewPath}/PopoverContentRightClick`}
>
{childProps => (
<ActionsPopover
{...childProps}
  viewPath={`${viewPath}/ActionsPopover`}
/>
)}
</PopoverContentRightClick>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}